"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/project/customerUserGroups");
exports.initialState = {
    isOpen: false,
    status: 'STANDBY',
    linkStatus: 'STANDBY',
    groups: [],
    selected: null
};
//#endregion
//#region LENSES
const isOpenLens = monocle.Lens.fromProp('isOpen');
const statusLens = monocle.Lens.fromProp('status');
const linkStatusLens = monocle.Lens.fromProp('linkStatus');
const groupsLens = monocle.Lens.fromProp('groups');
const selectedLens = monocle.Lens.fromProp('selected');
const methods = {};
exports.methods = methods;
// Fetching
methods[Actions.FETCH_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
methods[Actions.FETCH_SUCCESS] = (state, action) => {
    const groups = action.payload.reduce((acc, x) => {
        if (x.group.type === 'CustomerCategoryUserGroup') {
            acc.push(x.group);
        }
        return acc;
    }, []);
    groups.sort((a, b) => b.name.localeCompare(a.name));
    return fp.function.compose(groupsLens.set(groups), statusLens.set('FETCHED'))(state);
};
methods[Actions.FETCH_FAILED] = (state, action) => statusLens.set('FAILED')(state);
// Link
methods[Actions.LINK_REQUEST] = (state, action) => linkStatusLens.set('FETCHING')(state);
methods[Actions.LINK_SUCCESS] = (state, action) => (Object.assign({}, exports.initialState));
methods[Actions.LINK_FAILED] = (state, action) => linkStatusLens.set('FAILED')(state);
// Others
methods[Actions.SET_SELECTED] = (state, action) => selectedLens.set(action.payload)(state);
methods[Actions.TOGGLE_MODAL] = (state, action) => isOpenLens.modify((x) => !x)(state);
methods[Actions.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
//# sourceMappingURL=customerUserGroups.js.map